import React, { Component, PropTypes } from 'react';

import S from './Loading.css';

export default class Loading extends Component {
  static propTypes = {
    message: PropTypes.string,
  }

  static defaultProps = {
    message: 'Loading'
  }

  render() {
    const { message } = this.props;

    return (
      <div className="mt5 tc silver">
        {message}
        <span className={S.animatedEllipsis}>
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Loading.jsx
 **/